module.exports = __webpack_public_path__ + "img/bio-pic-2-118-184.8d182ae8.jpg";